import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-circle-s",
  "use": "icon-close-circle-s-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-close-circle-s\"><path d=\"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm4.061 15.179l-1.62-.007L12 13.262 9.562 16.17l-1.623.008a.195.195 0 01-.197-.197c0-.046.018-.09.047-.128l3.194-3.805L7.79 8.243a.197.197 0 01.15-.324l1.623.008L12 10.837l2.438-2.908 1.62-.007c.109 0 .197.086.197.196 0 .047-.017.09-.046.128l-3.19 3.803 3.192 3.806a.197.197 0 01-.15.324z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol